import { render, staticRenderFns } from "./TheFaq.vue?vue&type=template&id=7dba36e0&scoped=true"
import script from "./TheFaq.vue?vue&type=script&lang=js"
export * from "./TheFaq.vue?vue&type=script&lang=js"
import style0 from "./TheFaq.vue?vue&type=style&index=0&id=7dba36e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dba36e0",
  null
  
)

export default component.exports